<script>
import moment from "moment";
import axios from '@/utils/axios';
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import DateRangePicker from "daterangepicker";

export default {
  inject: ['setLoading'],

  data() {
    return {
      errors: {},
      title: "Reports",
      text: "Option Usage",
      text1: "Reports",
      filter: {
        from_date: '',
        to_date: '',
      },
      option_usage: [],
    };
  },

  computed: {
    maxOptionUsage() {
      if (!this.option_usage.length) return 0;
      return Math.max(...this.option_usage.map(o => o.times_chosen));
    },

    groupedOptionUsage() {
      const groups = {};
      this.option_usage.forEach(row => {
        if (!groups[row.option_name]) groups[row.option_name] = [];
        groups[row.option_name].push(row);
      });
      return groups;
    },
  },

  mounted() {
    const start = moment().subtract(1, "month");
    const end = moment();

    new DateRangePicker(
      this.$refs.dateRangeInput,
      {
        startDate: start,
        endDate: end,
        locale: {
          format: "DD/MM/YYYY",
          separator: " - "
        },
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        }
      },
      (start, end) => {
        this.setDateRange(start, end);
      },
      this.booking_range
    );

    this.setDateRange(start, end);
    this.filterReport();
  },

  methods: {
    booking_range(start, end) {
      return start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");
    },

    setDateRange(start, end) {
      this.filter.from_date = start.format("YYYY-MM-DD");
      this.filter.to_date = end.format("YYYY-MM-DD");
    },

    buildPayload(extra = {}) {
      const payload = {
        date_from: this.filter.from_date,
        date_to: this.filter.to_date,
        ...extra,
      };

      Object.keys(payload).forEach((key) => {
        if (payload[key] === '' || payload[key] === null || payload[key] === undefined) {
          delete payload[key];
        }
      });

      return payload;
    },

    async filterReport() {
      this.errors = {};
      this.setLoading(true);
      try {
        const payload = this.buildPayload();
        const query_string = new URLSearchParams(payload).toString();
        const response = await axios.get(`/reports/quotation/option-usage?${query_string}`);
        this.option_usage = response.data.data;
      } catch (error) {
        if (error.type == 'validation') {
          this.errors = error.errors;
        } else {
          this.$swalToast(error.message, 'error');
        }
      } finally {
        this.setLoading(false);
      }
    },

    async quickExport(format) {
      const payload = this.buildPayload({ export: format });
      await this.downloadExport('/reports/quotation/option-usage', payload);
    },

    async downloadExport(url, payload) {
      this.setLoading(true);
      try {
        const query_string = new URLSearchParams(payload).toString();
        const response = await axios.get(`${url}?${query_string}`, {
          responseType: 'blob',
        });

        const blob = new Blob([response.data], {
          type: response.headers['content-type'],
        });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);

        const format = payload.export;
        let filename = `option_usage_report_${this.$timeStamp()}.${format}`;
        const disposition = response.headers['content-disposition'];

        if (disposition && disposition.indexOf('filename=') !== -1) {
          const filenameMatch = disposition.match(/filename="?(.+)"?/);
          if (filenameMatch && filenameMatch.length === 2) {
            filename = filenameMatch[1];
          }
        }

        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);

        this.$swalToast('Export downloading...', 'success');
      } catch (error) {
        console.error(error);
        this.$swalToast(error?.response?.data?.message || 'Export failed', 'error');
      } finally {
        this.setLoading(false);
      }
    },
  }
};
</script>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="d-none my-xl-auto right-content align-items-center flex-wrap">
          <div class="me-2 mb-2" v-if="option_usage?.length">
            <div class="dropdown">
              <a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center" data-bs-toggle="dropdown">
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click="quickExport('csv')">
                    <i class="ti ti-file-type-csv me-1"></i>Export as CSV
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Filters -->
      <div class="card border-0">
        <div class="card-body d-flex align-items-center justify-content-center flex-wrap pb-1">
          <div class="d-flex align-items-center flex-wrap mb-1">
            <div class="me-3">
              <div class="input-icon-end position-relative">
                <input type="text" class="form-control date-range bookingrange" ref="dateRangeInput" placeholder="dd/mm/yyyy - dd/mm/yyyy">
                <span class="input-icon-addon"><i class="ti ti-chevron-down"></i></span>
              </div>
            </div>
            <div class="me-3">
              <button type="button" class="btn btn-dark" @click="filterReport()">
                <i class="ti ti-search"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="card border-0 shadow-sm">
            <div class="custom-datatable-filter table-responsive">
              <table class="table table-hover align-middle mb-0" v-if="option_usage?.length">
                <thead class="table-light">
                  <tr>
                    <th>#</th>
                    <th>Option</th>
                    <th>Value</th>
                    <th>Times Chosen</th>
                    <th style="width: 35%;">Usage</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in option_usage" :key="index">
                    <td class="text-muted">{{ index + 1 }}.</td>
                    <td class="fw-medium">{{ row.option_name }}</td>
                    <td>{{ row.value }}</td>
                    <td>{{ row.times_chosen }}</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <div class="progress flex-grow-1 me-2" style="height:6px;">
                          <div
                            class="progress-bar bg-primary"
                            :style="{ width: (row.times_chosen / maxOptionUsage * 100) + '%' }"
                          ></div>
                        </div>
                        <small class="fw-semibold">{{ row.times_chosen }}</small>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div v-else class="p-4 text-center text-muted">
                <i class="ti ti-file-off d-block mb-2" style="font-size:32px;"></i>
                No records found.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-footer></app-footer>
  </div>
</template>